export const DEFAULT_PROMO_DISCOUNT_PERCENT = 6;

function padTimePart(value) {
  return String(value).padStart(2, "0");
}

export function parsePromoDate(value) {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function toDateTimeLocalValue(value) {
  const date = parsePromoDate(value);

  if (!date) {
    return "";
  }

  return [
    date.getFullYear(),
    padTimePart(date.getMonth() + 1),
    padTimePart(date.getDate()),
  ].join("-") + `T${padTimePart(date.getHours())}:${padTimePart(date.getMinutes())}`;
}

export function toIsoFromDateTimeLocal(value) {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

export function getPromoTiming(
  { promoActive, promoStartAt, promoEndAt },
  nowInput = new Date()
) {
  const now = parsePromoDate(nowInput) || new Date();
  const startDate = parsePromoDate(promoStartAt);
  const endDate = parsePromoDate(promoEndAt);

  if (!promoActive) {
    return {
      status: "inactive",
      isDiscountActive: false,
      showCountdown: false,
      remainingMs: 0,
      startDate,
      endDate,
    };
  }

  if (startDate && endDate && startDate >= endDate) {
    return {
      status: "invalid",
      isDiscountActive: false,
      showCountdown: false,
      remainingMs: 0,
      startDate,
      endDate,
    };
  }

  if (startDate && now < startDate) {
    return {
      status: "upcoming",
      isDiscountActive: false,
      showCountdown: true,
      remainingMs: startDate.getTime() - now.getTime(),
      startDate,
      endDate,
    };
  }

  if (endDate && now >= endDate) {
    return {
      status: "ended",
      isDiscountActive: false,
      showCountdown: false,
      remainingMs: 0,
      startDate,
      endDate,
    };
  }

  return {
    status: "live",
    isDiscountActive: true,
    showCountdown: Boolean(endDate),
    remainingMs: endDate ? endDate.getTime() - now.getTime() : 0,
    startDate,
    endDate,
  };
}

export function formatPromoCountdown(milliseconds) {
  const safeMs = Math.max(Number(milliseconds || 0), 0);
  const totalMinutes = Math.floor(safeMs / 60000);
  const totalHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${totalHours}h ${padTimePart(minutes)}m`;
}

export function getPromoPrice(price, promoActive, discountPercent = DEFAULT_PROMO_DISCOUNT_PERCENT) {
  const numericPrice = Number(price || 0);

  if (!promoActive) {
    return numericPrice;
  }

  const safeDiscount = Math.min(Math.max(Number(discountPercent || 0), 0), 100);
  return Number((numericPrice * (1 - safeDiscount / 100)).toFixed(2));
}

export function getPromoSavings(price, promoActive, discountPercent = DEFAULT_PROMO_DISCOUNT_PERCENT) {
  const numericPrice = Number(price || 0);
  const promoPrice = getPromoPrice(numericPrice, promoActive, discountPercent);
  return Number((numericPrice - promoPrice).toFixed(2));
}